import data from "../data/nearbyguide.json";
import slugify from "./slugify";

/**
 * Get full city data by city slug
 */
export const getCityData = (citySlug) => {
  if (!citySlug) return null;
  return data.cities?.[citySlug] || null;
};

/**
 * Get category list for a city
 */
export const getCityCategories = (citySlug) => {
  const city = getCityData(citySlug);
  if (!city) return null;

  return Object.keys(city).filter((key) => Array.isArray(city[key]));
};

/**
 * Get items of a category in a city
 */
export const getCategoryItems = (citySlug, category) => {
  const city = getCityData(citySlug);
  if (!city || !Array.isArray(city[category])) return [];

  return city[category];
};

/**
 * 🔥 Get single item by slug (BULLETPROOF)
 */
export const getItemData = (citySlug, category, itemSlug) => {
  const items = getCategoryItems(citySlug, category);
  if (!items.length || !itemSlug) return null;

  const normalizedSlug = slugify(itemSlug);

  return items.find((item) => slugify(item.name) === normalizedSlug) || null;
};
